import React from "react";
import { useIntl } from "react-intl";

import loginService from "@app/services/auth/loginService";

import useHistory from "@utils/useHistory";

import { FORGOT_PASSWORD } from "@utils/constant";

import { ERROR_UNAUTHORISED } from "./LoginCredentialsForm.constants";

export const useLoginCredentialsForm = ({ onSubmit, onError }) => {
  const history = useHistory();
  const { messages } = useIntl();

  const [showInvalidDataError, setShowInvalidDataError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleLoginSubmit = async values => {
    try {
      setIsLoading(true);

      const { data: authData = {} } = await loginService({
        email: values.email,
        password: values.login_password,
      });

      onSubmit(authData, values.email);
    } catch (e) {
      const { response: { data = {} } = {} } = e;
      const { error = "" } = data;

      if (error === ERROR_UNAUTHORISED) {
        setShowInvalidDataError(true);
      } else {
        onError(messages.consent_BankIdError);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnInputChange = (onChange, event) => {
    setShowInvalidDataError(false);
    onChange(event);
  };

  const handleRedirectToForgotPassword = React.useCallback(
    () => history.push(FORGOT_PASSWORD),
    [history]
  );

  return {
    handleLoginSubmit,
    handleOnInputChange,
    handleRedirectToForgotPassword,
    showInvalidDataError,
    isLoading,
  };
};
